import { createFileRoute, Navigate } from '@tanstack/react-router';

/**
 * «Personale esterno» non è più una pagina (03-11-2026): è l'elenco dei dipendenti col filtro
 * «Esterni», che mostra le stesse righe (partita IVA, frequenza, tariffa) **col nome della persona**,
 * che qui mancava. I dati si scrivono dalla scheda del collaboratore, «Dati esterno».
 */
export const Route = createFileRoute('/_app/workforce/external')({
  component: () => <Navigate to="/hr/employees" search={{ type: 'external' }} replace />,
});
